namespace TabAurous.OMS {
    export interface FormatMasterForm {
        FormatType: FormatMasterEditor;
        Separator: SeparatorEditor;
        StartIndex: Serenity.DecimalEditor;
        Prefix: Serenity.StringEditor;
        DesignPrefixEditor: _Ext.EmptyLookupEditor;
        PrefixCode: SKUPrefixEditor;
        PrefixDate: PrefixEditor;
        Suffix: Serenity.StringEditor;
        DesignSuffixEditor: _Ext.EmptyLookupEditor;
        IncrementBy: Serenity.IntegerEditor;
        LastNumber: Serenity.IntegerEditor;
        PrefillwithZero: Serenity.BooleanEditor;
        Noofzeroes: Serenity.IntegerEditor;
        BranchWise: Serenity.BooleanEditor;
        CounterWise: Serenity.BooleanEditor;
        ResetMonthly: Serenity.BooleanEditor;
        ResetYearly: Serenity.BooleanEditor;
        Format: Serenity.StringEditor;
        Lock: Serenity.BooleanEditor;
        LastMonth: Serenity.IntegerEditor;
        LastYear: Serenity.IntegerEditor;
        DesignSuffix: Serenity.StringEditor;
        DesignPrefix: Serenity.StringEditor;
    }

    export class FormatMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.FormatMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FormatMasterForm.init)  {
                FormatMasterForm.init = true;

                var s = Serenity;
                var w0 = FormatMasterEditor;
                var w1 = SeparatorEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;
                var w4 = _Ext.EmptyLookupEditor;
                var w5 = SKUPrefixEditor;
                var w6 = PrefixEditor;
                var w7 = s.IntegerEditor;
                var w8 = s.BooleanEditor;

                Q.initFormType(FormatMasterForm, [
                    'FormatType', w0,
                    'Separator', w1,
                    'StartIndex', w2,
                    'Prefix', w3,
                    'DesignPrefixEditor', w4,
                    'PrefixCode', w5,
                    'PrefixDate', w6,
                    'Suffix', w3,
                    'DesignSuffixEditor', w4,
                    'IncrementBy', w7,
                    'LastNumber', w7,
                    'PrefillwithZero', w8,
                    'Noofzeroes', w7,
                    'BranchWise', w8,
                    'CounterWise', w8,
                    'ResetMonthly', w8,
                    'ResetYearly', w8,
                    'Format', w3,
                    'Lock', w8,
                    'LastMonth', w7,
                    'LastYear', w7,
                    'DesignSuffix', w3,
                    'DesignPrefix', w3
                ]);
            }
        }
    }
}
